import type { Dispatch, SetStateAction } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { EditorState } from "../connectorManagerHelpers";

export const BeehiivFields = ({
  editor,
  setEditor,
}: {
  editor: EditorState;
  setEditor: Dispatch<SetStateAction<EditorState>>;
}) => (
  <div className="space-y-3">
    <div className="space-y-2">
      <Label htmlFor="connector-beehiiv-pub">Publication ID</Label>
      <Input
        id="connector-beehiiv-pub"
        value={editor.beehiivPublicationId}
        onChange={(e) =>
          setEditor((s) => ({ ...s, beehiivPublicationId: e.target.value }))
        }
        placeholder="pub_xxxxxxxx"
        autoComplete="off"
      />
      <p className="text-xs text-muted-foreground">
        In Beehiiv, open Settings → Publications and copy the publication ID (starts with{" "}
        <code>pub_</code>).
      </p>
    </div>

    <div className="space-y-2">
      <Label htmlFor="connector-beehiiv-secret">
        Beehiiv API key (V2) {editor.connector ? "(leave blank to keep)" : ""}
      </Label>
      <Input
        id="connector-beehiiv-secret"
        type="password"
        autoComplete="new-password"
        value={editor.secretValue}
        onChange={(e) =>
          setEditor((s) => ({ ...s, secretValue: e.target.value, clearSecret: false }))
        }
        placeholder="Stored encrypted"
        disabled={editor.clearSecret}
      />
      <p className="text-xs text-muted-foreground">
        Create an API key at Beehiiv → Settings → Integrations → API. Used to create draft posts
        on dispatch — Excerptus never publishes for you.
      </p>
      {editor.connector && (
        <label className="flex items-center gap-2 text-xs text-muted-foreground">
          <input
            type="checkbox"
            checked={editor.clearSecret}
            onChange={(e) =>
              setEditor((s) => ({ ...s, clearSecret: e.target.checked, secretValue: "" }))
            }
          />
          Clear stored secret
        </label>
      )}
    </div>

    <p className="rounded-md border border-dashed border-border bg-muted/30 p-3 text-xs text-muted-foreground">
      Beehiiv has no public image upload endpoint. Excerptus-hosted images in your draft will be
      stripped and listed as a publish checklist — re-upload them inside Beehiiv before sending.
    </p>
  </div>
);
